<script>
import { Overlay } from '../../'
export default {
    name: 'PriceEfficiency', mixins: [Overlay],
    methods: {
        meta_info() { return { author: 'TradingCandle', version: '1.0.0', desc: 'Price Efficiency Ratio',
            preset: { name: 'PriceEfficiency $length', side: 'offchart',
                settings: { color: '#2962ff', colors: ['#2962ff', '#ef5350'], lineWidth: 1.5, skipNaN: true } } } },
        use_for() { return ['PriceEfficiency'] },
        calc() { return {
            props: { length: { def: 20, text: 'Length', min: 1, step: 1 } },
            conf: { renderer: 'Spline' },
            update: `let moves = ts(Math.abs(close[0] - close[1]))
                    let total = sum(moves, length)[0]
                    return total > 0 ? 100 * Math.abs(close[0] - close[length]) / total : 0`
        } },
    },
}
</script>
